import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";

import {
  getClientIdentifier,
  getCurrentUserClient,
  getCurrentUserPermissions,
} from "@/components/currentUser/CurrentUser.state";
import { ALL_PERMISSIONS } from "@/components/currentUser/constants";
import {
  requestAdministeredUsers,
  fetchRoleCombinations,
} from "@/components/administeredUsers/AdministeredUsers.state";
import { requestAgencies } from "@/components/currentUser/Agencies.state";
import { requestClients } from "@/components/adminPage/AdminPage.state";
import { requestEpic } from "@/APIClient/observable.util";
import {
  getMetaConfig,
  getSettingsProfileConfig,
  getSettingsRootConfig,
} from "@/APIClient";
import {
  setClientSettings,
  setClientSettingsError,
  setClientMeta,
  setClientMetaError,
  SETTINGS_LEVEL_PROFILE,
  SETTINGS_LEVEL_ROOT,
} from "@/state/client.state";

const FETCH_AUTHORIZED_DATA = "appConfig/FETCH_AUTHORIZED_DATA";
export const fetchAuthorizedData = () => ({
  type: FETCH_AUTHORIZED_DATA,
});

const fetchAuthorizedDataEpic = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_AUTHORIZED_DATA),
    RxOp.mergeMap(() => {
      let authorizedRequests = [];

      const permissions = getCurrentUserPermissions(state$.value)?.value ?? [];
      const {
        userCanViewAdministeredUsers,
        userCanSearchAgencies,
        userCanViewClientsList,
      } = ALL_PERMISSIONS;

      if (permissions.includes(userCanViewAdministeredUsers)) {
        /* Gets valid role combinations for user administration */
        authorizedRequests.push(fetchRoleCombinations());

        if (
          getClientIdentifier(state$.value) &&
          !state$.value.administeredUsers?.requestAdministeredUsersPending
        ) {
          authorizedRequests.push(requestAdministeredUsers());
        }
      }
      if (permissions.includes(userCanSearchAgencies))
        authorizedRequests.push(requestAgencies());
      if (permissions.includes(userCanViewClientsList))
        authorizedRequests.push(requestClients());

      const stream = [Rx.of(...authorizedRequests)];

      const client = getCurrentUserClient(state$.value).value?.slug;
      if (client) {
        stream.push(
          requestEpic({
            requestMethod: getSettingsRootConfig,
            requestArgs: { client },
            onSuccess: (res) => Rx.of(setClientSettings(res, SETTINGS_LEVEL_ROOT)),
            onFailure: (err) =>
              Rx.of(setClientSettingsError(err, SETTINGS_LEVEL_ROOT)),
          }),
          requestEpic({
            requestMethod: getSettingsProfileConfig,
            requestArgs: { client },
            onSuccess: (res) =>
              Rx.of(setClientSettings(res, SETTINGS_LEVEL_PROFILE)),
            onFailure: (err) =>
              Rx.of(setClientSettingsError(err, SETTINGS_LEVEL_PROFILE)),
          })
        );
        stream.push(
          requestEpic({
            requestMethod: getMetaConfig,
            requestArgs: { client },
            onSuccess: (res) => Rx.of(setClientMeta(res)),
            onFailure: (err) => Rx.of(setClientMetaError(err)),
          })
        );
      }
      return Rx.concat(stream);
    }),
    RxOp.concatAll()
  );

const appConfigEpic = fetchAuthorizedDataEpic;

export default appConfigEpic;
